import { Component } from '@angular/core';
import { TableColumnDirective } from '../column.directive';

@Component({
  selector: 'local-seo-presence-accuracy',
  templateUrl: './presence-accuracy.component.html',
  styleUrls: ['./presence-accuracy.component.scss'],
  standalone: false,
})
export class PresenceAccuracyComponent extends TableColumnDirective {
  constructor() {
    super();
  }
}
